import styled from 'styled-components';
// import {media} from '../../utils/styleUtils'

const H2 = styled.h2`
  font-size: 2rem;
  line-height: 1;
  text-transform: uppercase;
`;

export default H2;
